import { combineEpics } from "redux-observable";
import { authEpic } from "./auth.Epic";
import { projectEpic } from "./project.Epic";
import { projectTabEpic } from "./calculation/calculation-input/projectTab.Epic";
import { projectHeaderEpic } from "./calculation/calculation-input/projectHeader.Epic";
import { calculationEpic } from "./calculation/calculation.epic";
import { fluidEpic } from "./calculation/calculation-input/fluid.epic";
import { tubingEpic } from "./calculation/calculation-input/tubing.epic";
import { wellEpic } from "./calculation/calculation-input/well.epic";
import { gasCalculationEpic } from "./calculation/calculation-output/gasCalculation.epic";
import { gasHandlerEpic } from "./calculation/calculation-output/gas-handler.epic";
import { basicEpic } from "./calculation/calculation-output/basicCalculation.epic";
import { pumpEpic } from "./calculation/calculation-output/pump.Epic";
import { gasProtectorEpic } from "./calculation/calculation-output/protector.Epic";
import { motorEpic } from "./calculation/calculation-output/motor.Epic";
import { cableEpic } from "./calculation/calculation-output/cable.Epic";
import { schematicEpic } from "./calculation/calculation-output/schematic.epic";
import { wellSurveyEpic } from "./calculation/calculation-output/wellSurvey.Epic";
import { surfaceEquipmentEpic } from "./calculation/calculation-output/surfaceEquipment.epic";
import { summaryEpic } from "./summary.Epic";
import { reportEpic } from "./report.Epic";
import { documentsEpic } from "./documents/documents.Epic";
import { commentsEpic } from "./comments/comments.Epic";
import { equipmentCatalogEpic } from "./equipment-catalog/equipment-catalog.Epic";
import { jetliftRootEpic } from "./jetlift/jetliftRoot.epic";

export const rootEpic = combineEpics(
    authEpic,
    projectEpic,
    projectTabEpic,
    projectHeaderEpic,
    calculationEpic,
    fluidEpic,
    tubingEpic,
    wellEpic,
    gasCalculationEpic,
    gasHandlerEpic,
    basicEpic,
    pumpEpic,
    gasProtectorEpic,
    motorEpic,
    cableEpic,
    schematicEpic,
    wellSurveyEpic,
    surfaceEquipmentEpic,
    summaryEpic,
    reportEpic,
    documentsEpic,
    commentsEpic,
    equipmentCatalogEpic,
    jetliftRootEpic,
);

